export const CONVERSATION_ASSIST_ROUTES = {
  HOME: 'home',
  RECOMMENDATION_SOURCES: 'recommendation',
  DETAILED_REPORTS: 'reports',
  SETTINGS: 'settings',
  WELCOME: 'welcome',
  KNOWLEDGE_BASES: 'kb',
  BOTS: 'bots',
};

export const CONVERSATION_ASSIST_MENUS = [
  {
    name: CONVERSATION_ASSIST_ROUTES.HOME,
    title: 'home',
  },
  {
    name: CONVERSATION_ASSIST_ROUTES.RECOMMENDATION_SOURCES,
    title: 'recommendation-sources',
  },
  {
    name: CONVERSATION_ASSIST_ROUTES.DETAILED_REPORTS,
    title: 'detailed-reports',
    featureFlag: '$isDetailedReportsEnabled',
  },
  {
    name: CONVERSATION_ASSIST_ROUTES.SETTINGS,
    title: 'settings',
  },
];

export const RECOMMENDATION_SOURCES_TAB_ID = {
  kb: 'kb',
  bot: 'bot',
};

export const RECOMMENDATION_SOURCES_MENU = [
  {
    id: RECOMMENDATION_SOURCES_TAB_ID.kb,
    name: CONVERSATION_ASSIST_ROUTES.KNOWLEDGE_BASES,
    title: 'kb',
  },
  {
    id: RECOMMENDATION_SOURCES_TAB_ID.bot,
    name: CONVERSATION_ASSIST_ROUTES.BOTS,
    title: 'bots',
  },
];

export const WELCOME_SUGGESTIONS_LINKS = [
  {
    link: 'https://knowledge.liveperson.com/release-notes',
    label: 'first',
  },
  {
    link: 'https://developers.liveperson.com/conversation-assist-overview.html',
    label: 'second',
  },
  {
    link: 'https://developers.liveperson.com/tutorials-guides-using-conversation-assist-overview.html',
    label: 'third',
  },
  {
    link: 'https://developers.liveperson.com/conversation-assist-agent-experience.html',
    label: 'fourth',
  },
  {
    link: 'https://developers.liveperson.com/conversation-assist-best-practices.html',
    label: 'fifth',
  },
  {
    link: 'https://talkyard.livepersonai.com/latest/conversation-assist',
    label: 'sixth',
  },
];

export const WELCOME_MAIN_POINTERS = ['first', 'second', 'third'];

export const TIME_PERIODS = [7, 30, 90];
export const ITEMS_PER_PAGE = [10, 20, 30];

export const REPORTS_TIME_PERIODS = ['all', 'daily', 'weekly', 'monthly'];

export const DIRECTION = {
  UP: 'up',
  DOWN: 'down',
};

Object.freeze(DIRECTION);

export const KB_THRESHOLDS = ['fair-good', 'good', 'very-good'];

export const baseCAWidgetPayload = {
  componentName: 'AWModuleWidget.ConversationAssist',
  deleted: false,
  description: '',
  enabled: true,
  mode: 'published',
  name: 'On-Demand Recommendations',
  path: 'p/lp-le-conversation-assist-recommendations/latest/AWModuleWidget.ConversationAssist.umd.js',
  span: '1',
  type: 'module',
  url: '',
};
